import _slicedToArray from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Fab, Collapse, withStyles, Tooltip } from '@material-ui/core';
import { FilterListOutlined as FilterIcon } from '@material-ui/icons';
import Form from '../form/Form';
import styles from './GridFilter.style';
import classnames from 'classnames';
import isUndefined from 'lodash/isUndefined';

var GridFilter = function GridFilter(props) {
  var onChange = props.onChange,
      classes = props.classes,
      fields = props.fields,
      defaultOpen = props.defaultOpen,
      buttons = props.buttons,
      formProps = props.formProps,
      collapseProps = props.collapseProps;
  /** Состояние открытости */

  var _useState = useState(isUndefined(defaultOpen) ? true : defaultOpen),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];
  /**
   * Открытие/скрытие фильтра
   */


  var toggleFilter = function toggleFilter() {
    setOpened(!opened);
  };
  /**
   * Сабмит формы фильтра
   * @param values
   * @param cb
   */


  var onSubmit = function onSubmit(values, cb) {
    onChange(values);

    if (cb) {
      cb();
    }
  };

  return React.createElement("div", {
    className: classnames(classes.filter, opened ? '' : classes.filterClosed)
  }, React.createElement(Collapse, Object.assign({
    in: opened,
    timeout: 'auto'
  }, collapseProps), React.createElement(Form, Object.assign({
    fields: fields,
    onSubmit: onSubmit,
    loading: false,
    type: 'filter',
    additionalButtons: buttons
  }, formProps))), React.createElement(Tooltip, {
    title: opened ? 'Скрыть фильтр' : 'Показать фильтр'
  }, React.createElement(Fab, {
    size: 'small',
    onClick: toggleFilter,
    "aria-label": 'Collapse',
    color: 'primary',
    className: classnames(classes.filterToggle, opened ? '' : classes.filterToggleClosed)
  }, React.createElement(FilterIcon, {
    fontSize: "small"
  }))));
};

export default withStyles(styles, {
  name: 'GridFilter',
  withTheme: true
})(GridFilter);